/* eslint-disable */
require('./addSample')
require('./addWorkflow')
require('./centrifugation')
require('./dispensing')
require('./editWorkflow')
require('./extraction')
require('./filtration')
require('./hplc')
require('./pause')
require('./pipetting')
require('./sonication')
require('./washing')
require('./weighing')
